import { Directive, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
declare const google: any;

@Directive({ selector: '[places-auto]' })

export class PlacesAutocompleteDirective implements OnInit {
    @Output() onSelect: EventEmitter<any> = new EventEmitter();
    private element: HTMLInputElement;

    constructor(elRef: ElementRef, private _map: MapsAPILoader) {
        this.element = elRef.nativeElement;
    }

    getFormattedAddress(place) {
        localStorage.setItem('place', JSON.stringify(place));
        const address = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
        for (let i in place.address_components) {

            let item = place.address_components[i];

            switch (item['types'][0]) {
                case 'locality':
                    address['city'] = item['long_name'];
                    break;
                case 'administrative_area_level_1':
                    address['state'] = item['long_name'];
                    address['stateCode'] = item['short_name'];
                    break;
                case 'country':
                    address['country'] = item['long_name'];
                    address['countryCode'] = item['short_name'];
                    break;
                case 'postal_code': address['zipCode'] = item['long_name'];
                    break;
                default:
                    address[item['types'][0]] = item['long_name'];
                    break;
            }
        }
        return address;
    }

    ngOnInit() {
        this._map.load().then(() => {
            const autocomplete = new google.maps.places.Autocomplete(this.element);
            google.maps.event.addListener(autocomplete, 'place_changed', () => {
                this.onSelect.emit(this.getFormattedAddress(autocomplete.getPlace()));
            });
        });
    }
}


// For reverse geocoding
// this._map.load().then(() => {
//     let geocoder = new google.maps.Geocoder;
//     geocoder.geocode({ 'location': { lat: e.coords.lat, lng: e.coords.lng }}, function (results, status) {
//         if (status === 'OK') {
//             if (results[0]) {
//                 console.log(results);
//             }
//         } else {
//             window.alert('Geocoder failed due to: ' + status);
//         }
//     });
// });